import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMessagesNotReadCounterMutation } from '../../../api/AuftragMessagesAPI';


interface ThisProps {
}

/**
 * @author noone
 */
const ChatButtonComponent: React.FC<ThisProps> = ({  }) => {

  const navigate = useNavigate();

  const [anzahlNeueNachrichten, setAnzahlNeueNachrichten] = useState<number>(0);

  const [getAnzahlUngelesen] = useGetMessagesNotReadCounterMutation();

  useEffect(() => {
    getAnzahlUngelesen().unwrap()
      .then( (zahl) => setAnzahlNeueNachrichten(zahl))
      .catch( (error) => console.log(error))
    ;
  }, [getAnzahlUngelesen]);

  return (
    <>
      <button
        onClick={() => navigate("/chat")}
        className="btn btn-outline-primary position-relative"
      >
        <i className="bi bi-chat"></i>

        {anzahlNeueNachrichten > 0 &&
          <span style={{ color: "white" }}
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-success"
          >
            {anzahlNeueNachrichten}
          </span>
        }
      </button>
    </>
  );

}

export default ChatButtonComponent;